import { styled } from '@mui/material/styles';
import MuiDrawer from '@mui/material/Drawer';

export const drawerWidth = 240;

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(({ theme, open }) => ({
  '& .MuiDrawer-paper': {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    boxSizing: 'border-box',
    ...(!open && {
      overflowX: 'hidden',
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      // eslint-disable-next-line
      width: theme.spacing(7),
      [theme.breakpoints.up('sm')]: {
        // eslint-disable-next-line
        width: theme.spacing(9),
      },
    }),
  },
}));

export default Drawer;
